export function AffiliateLinkNote({ className = "" }) {
  return (
    <p className={`text-[10px] leading-snug text-aura-muted ${className}`} data-testid="affiliate-link-note">
      Affiliate link. Shoptosa may earn a commission if you buy, at no extra cost to you.
    </p>
  );
}

export function AffiliateSiteNotice({ className = "" }) {
  return (
    <p className={`text-xs leading-relaxed text-aura-muted max-w-2xl ${className}`} data-testid="affiliate-site-disclosure">
      Affiliate disclosure: some product links on Shoptosa are affiliate links. If you buy through them, Shoptosa may earn a commission at no extra cost to you. Checkout stays on the retailer’s website.
    </p>
  );
}
